const translation = {
  nav: {
    home: 'Home',
    about: 'About',
    services: 'Services',
    wedding: 'Wedding',
    weddingStories: 'Real Wedding Stories',
    printing: 'Printing',
    gallery: 'Gallery',
    contact: 'Contact',
  },
  seo: {
    wedding: {
      title: 'Wedding Photography in Madurai & Karaikudi | Shabi Media',
      description:
        'Candid & traditional wedding photography, 4K cinematic films, drone coverage and premium albums in Madurai, Karaikudi and across Tamil Nadu. Trusted since 1988.',
    },
    services: {
      title: 'Photography & Videography Services in Madurai | Shabi Media',
      description:
        'Wedding, pre-wedding, baby, corporate, portrait and cinematic videography services in Madurai & Karaikudi. Designed & delivered by our own in-house team since 1988.',
    },
    gallery: {
      title: 'Photography Portfolio & Gallery | Shabi Media, Madurai',
      description:
        'Browse our wedding, pre-wedding, baby, portrait, corporate and event photography gallery — captured across Madurai, Karaikudi and Tamil Nadu.',
    },
    story: {
      title: 'Aarthi & Karthik: A Temple Wedding in Madurai | Shabi Media',
      description:
        'Real wedding story — how Shabi Media photographed Aarthi & Karthik\'s full-day South Indian temple wedding in Madurai, from muhurtham rituals to the reception.',
    },
    weddingStories: {
      title: 'Real Wedding Stories in Madurai & Tamil Nadu | Shabi Media',
      description:
        'Real South Indian wedding stories photographed by Shabi Media — Madurai, Karaikudi, Rameswaram, Trichy and Thanjavur. Rituals, timelines, photo stories and couple reviews.',
    },
  },
  hero: {
    tagline: 'Turning Moments Into Memories',
    titleLine1: 'We Turn Your Moments',
    titleLine2pre: 'Into ',
    titleLine2Accent: 'Timeless Memories',
    desc: 'Shabi Media is a photography, videography and creative design studio crafting wedding, pre-wedding, baby and corporate stories — plus premium print work from photo frames to flex banners.',
    badgeSince: 'Since 1988',
    badgeWeddings: '12,000+ Weddings',
    badgePlaces: 'Madurai • Karaikudi',
  },
  marquee: {
    items: [
      'Wedding Photography',
      'Pre-Wedding Shoots',
      'Baby & Newborn',
      'Cinematic Films',
      'Photo Frames',
      'Visiting Cards',
      'ID Cards',
      'Pamphlets',
      'Brochures',
      'Flex & Banners',
      'Corporate Shoots',
      'Album Design',
    ],
  },
  common: {
    bookShoot: 'Book a Shoot',
    bookShootWhatsapp: 'Book a Shoot on WhatsApp',
    bookOnWhatsapp: 'Book on WhatsApp',
    viewWork: 'View Our Work',
    sendEnquiry: 'Send Enquiry',
    whatsappUs: 'WhatsApp Us',
    getQuote: 'Get Quote',
    getPrintQuote: 'Get a Print Quote',
    seeOurWork: 'See Our Work',
    discussEvent: 'Discuss Your Event',
    home: 'Home',
    enquire: 'Enquire Now',
    viewDetails: 'View Details',
    enquireMessage:
      'Hi Shabi Media, I would like to enquire about {{topic}}. Please share the details and pricing.',
  },
  about: {
    label: 'Our Story',
    title: "Three Decades of Capturing Tamil Nadu's Most Beautiful Moments",
    para1: 'What began in 1988 as a small studio in Thirupathur, Sivagangai Dist. has grown into a complete visual studio. Today Shabi Media blends traditional craft with modern cinematic technique — photographing weddings, families and businesses, and designing everything from albums to flex banners.',
    para2: 'Every project is handled by our in-house team of photographers, cinematographers, editors and designers, so your story stays consistent from the first frame to the final print.',
    highlightPhotography: 'Photography',
    highlightVideography: 'Videography',
    highlightDesign: 'Creative Design',
    highlightPrinting: 'Printing',
    quote: 'People, places, emotions — our lens, your story.',
  },
  services: {
    label: 'Photography & Videography',
    title: 'Stories We Love To Tell',
    intro: 'From the first look to the last dance, we cover every chapter with a cinematic eye and an unhurried, personal approach.',
    items: {
      wedding: {
        title: 'Wedding Photography',
        desc: 'Full-day candid and traditional coverage that keeps every ritual, emotion and celebration exactly as it happened.',
        features: ['Candid + Traditional', 'Two Photographers', 'Cinematic Teaser'],
      },
      'pre-wedding': {
        title: 'Pre-Wedding & Engagement',
        desc: 'Concept-driven shoots at your favourite locations, styled and directed to feel effortless and cinematic.',
        features: ['Location Scouting', 'Styling Guidance', 'Concept Storyboard'],
      },
      baby: {
        title: 'Baby & Newborn',
        desc: 'Gentle, patient studio sessions for newborns, birthdays and growing families — safe, warm and beautifully lit.',
        features: ['Studio Props', 'Family Portraits', 'Milestone Albums'],
      },
      videography: {
        title: 'Videography & Film',
        desc: '4K cinematic films, drone coverage and highlight reels edited to tell your story with rhythm and feeling.',
        features: ['4K Cinematic', 'Drone Coverage', 'Highlight Reels'],
      },
      corporate: {
        title: 'Corporate & Product',
        desc: 'Sharp, on-brand imagery for businesses — team profiles, events, product shoots and catalogue photography.',
        features: ['Team Profiles', 'Product Shoots', 'Event Coverage'],
      },
      portrait: {
        title: 'Portraits & Fashion',
        desc: 'Studio and outdoor portraits with controlled lighting, styling and retouching that flatters every subject.',
        features: ['Studio Lighting', 'Pro Retouching', 'Model Portfolio'],
      },
    },
  },
  printing: {
    label: 'Print & Design Studio',
    title: 'Everything Your Brand Needs, Printed In-House',
    intro: 'Photo frames, ID cards, visiting cards, pamphlets, brochures, flex and banners — designed and printed by our own team with premium finishes.',
    items: {
      framing: {
        title: 'Photo Frames',
        desc: 'Premium wood, metal and acrylic frames in every size, mounted and finished with archival quality prints.',
        tag: 'Most Loved',
      },
      'visiting-card': {
        title: 'Visiting Cards',
        desc: 'Spot UV, textured and gold-foil business cards that make a strong first impression in hand.',
        tag: 'Foil & Texture',
      },
      'id-card': {
        title: 'ID Cards',
        desc: 'School, college and staff ID cards printed with lanyards, holders and batch-wise organisation.',
        tag: 'Bulk Ready',
      },
      pamphlet: {
        title: 'Pamphlets & Flyers',
        desc: 'Eye-catching single and multi-colour flyers for offers, openings and local campaigns.',
        tag: 'Fast Turnaround',
      },
      brochure: {
        title: 'Brochures & Catalogues',
        desc: 'Bi-fold, tri-fold and multi-page brochures with clean layouts that present your brand beautifully.',
        tag: 'Design Included',
      },
      flex: {
        title: 'Flex & Banners',
        desc: 'Large-format flex, vinyl and backdrop printing for events, shops and outdoor promotions.',
        tag: 'Large Format',
      },
    },
  },
  gallery: {
    label: 'Portfolio',
    title: 'A Glimpse Of Our Work',
    intro: 'Weddings, pre-wedding stories, newborns, corporate shoots and celebrations — all captured with a modern, professional eye. Tap any frame to view it larger.',
    footerBefore: 'Every family has a story. Let us tell yours — ',
    footerLink: 'book a session',
    footerAfter: '.',
    categories: {
      all: 'All Works',
      wedding: 'Wedding',
      'pre-wedding': 'Pre-Wedding',
      baby: 'Baby & Kids',
      corporate: 'Corporate',
      portrait: 'Portraits',
      event: 'Events',
    },
    items: {
      g1: { title: 'Aarthi & Karthik — Temple Wedding', place: 'Madurai' },
      g2: { title: 'Bridal Portrait — Golden Hour', place: 'Karaikudi' },
      g3: { title: 'Sunset Silhouette Session', place: 'Rameswaram' },
      g4: { title: 'Garden Engagement Story', place: 'Madurai' },
      g5: { title: 'Newborn Dreams', place: 'Studio' },
      g6: { title: 'First Birthday Joy', place: 'Karaikudi' },
      g7: { title: 'Annual Conference Coverage', place: 'Madurai' },
      g8: { title: 'Executive Headshots', place: 'Studio' },
      g9: { title: 'Cinematic Studio Portrait', place: 'Studio' },
      g10: { title: 'Moody Fashion Frame', place: 'Studio' },
      g11: { title: 'Stage & Celebration', place: 'Karaikudi' },
      g12: { title: 'Award Night Moments', place: 'Madurai' },
    },
  },
  why: {
    label: 'Why Shabi Media',
    title: 'A Studio You Can Trust With Your Story',
    intro: 'We combine decades of experience with modern technology and a fully in-house team, so nothing is left to chance — from the first shot to the final print.',
    statS1: 'Years of Legacy',
    statS2: 'Weddings Covered',
    statS3: 'Happy Families',
    statS4: 'Studio Cities',
    points: {
      w1: { title: 'Legacy Since 1988', desc: 'Three decades of experience photographing the people and celebrations of Tamil Nadu.' },
      w2: { title: 'In-House Expert Team', desc: 'Photographers, cinematographers, editors and designers working under one roof.' },
      w3: { title: 'Advanced Post Production', desc: 'Colour grading, retouching and cinematic editing that makes every frame shine.' },
      w4: { title: 'Print & Design Studio', desc: 'From albums and frames to visiting cards and flex banners — all printed in house.' },
      w5: { title: 'On-Time Delivery', desc: 'Clear timelines and dependable delivery, so you never miss the moment or the deadline.' },
      w6: { title: 'Transparent Pricing', desc: 'Honest packages with no hidden costs, tailored to every family and business budget.' },
    },
  },
  process: {
    label: 'How We Work',
    title: 'Simple, From Start To Finish',
    steps: {
      p1: { title: 'Share Your Idea', desc: 'Tell us your event, date and the style you love. We listen first and plan with you.' },
      p2: { title: 'Plan & Design', desc: 'We lock the schedule, locations and concepts, and design any print material needed.' },
      p3: { title: 'Shoot Day', desc: 'Our crew captures every detail with professional gear, lighting and direction.' },
      p4: { title: 'Edit & Deliver', desc: 'Cinematic edits, retouched albums and printed products delivered on time.' },
    },
  },
  testimonials: {
    label: 'Kind Words',
    title: 'Loved By Families & Businesses',
    rating: '4.9 / 5 from 1,200+ reviews',
    items: {
      t1: {
        name: 'Aarthi & Karthik',
        role: 'Wedding — Madurai',
        quote: 'They captured every ritual so beautifully that watching the album still gives us goosebumps. The candid shots are simply priceless.',
      },
      t2: {
        name: 'Ramya S.',
        role: 'Newborn Session — Karaikudi',
        quote: 'So patient and gentle with our newborn. The studio was warm and safe, and the photos came out dreamy. Highly recommended.',
      },
      t3: {
        name: 'Vetri Enterprises',
        role: 'Corporate — Madurai',
        quote: 'Our team profiles, product photos and annual event coverage were all handled professionally. Great value and quick delivery.',
      },
      t4: {
        name: 'Sri Lakshmi Mahal',
        role: 'Venue Promotions — Karaikudi',
        quote: 'Shabi Media designed and printed all our flex banners and brochures. Clean design, rich colours and finished on schedule.',
      },
    },
  },
  faq: {
    label: 'FAQ',
    title: 'Questions, Answered',
    intro: 'Pricing, delivery timelines and travel charges — the things our clients ask us the most. Cannot find your answer? Message us any time.',
    cardTitle: 'Still have a question?',
    cardText: 'Talk to our team directly and get answers for your exact date and budget.',
    items: {
      f1: {
        q: 'How much does a wedding shoot cost?',
        a: 'Every wedding is different, so our packages are tailored to your date, number of days and team size. Our most-booked Wedding Signature package typically covers two photographers, a cinematographer, drone coverage, edited photos and albums. Share your date with us and we will send an exact quote — with no hidden costs.',
      },
      f2: {
        q: 'Do you charge extra for travel or outstation shoots?',
        a: 'Shoots within Madurai and Karaikudi are covered in the package. For locations outside these cities, a travel charge applies — we quote it upfront based on distance, and for far destinations we also include stay. You will always know the full cost before you confirm.',
      },
      f3: {
        q: 'How long until we receive our photos and album?',
        a: 'Edited highlights are ready within 7–10 days of the shoot. Full retouched albums take about 3–4 weeks, and printed products (albums, frames) are delivered within 1–2 weeks after design approval. We share a clear timeline the day you book.',
      },
      f4: {
        q: 'How do we block our date and what is the advance?',
        a: 'A 30% advance confirms and blocks your date, with the balance payable on delivery. You can pay by UPI, bank transfer or cash at the studio. WhatsApp us your date and we will hold it for you while we finalise the details.',
      },
      f5: {
        q: 'Can we customise a package?',
        a: 'Yes — every package is fully customisable. You can add a second day, extra cinematographers, drone coverage, a themed baby session or print work, and remove anything you do not need. Tell us your priorities and budget and we will build the right mix.',
      },
      f6: {
        q: 'How long does printing take for cards, brochures and flex?',
        a: 'Visiting cards and ID cards are usually ready in 2–3 working days. Brochures and catalogues take 4–5 working days, and flex or banner printing can be completed in 1–2 working days for urgent orders. Bulk and recurring orders get priority scheduling.',
      },
      f7: {
        q: 'Do you deliver digital files and online galleries?',
        a: 'Yes. You receive high-resolution digital files plus a private online gallery you can share with family and friends. Albums and frames are delivered as physical prints, and you keep full ownership of all your files.',
      },
    },
  },
  contact: {
    label: "Let's Talk",
    title: 'Book A Shoot Or Get A Quote',
    intro: 'Tell us about your event or print requirement and our team will get back to you within a day.',
    detailCall: 'Call / WhatsApp',
    detailEmail: 'Email',
    detailStudios: 'Based In',
    detailHours: 'Open Hours',
    hours: 'Mon – Sat, 9:30 AM – 8:30 PM',
    locations: 'Tamil Nadu, India • Online Services',
    formName: 'Full Name',
    formNamePh: 'Your name',
    formPhone: 'Phone',
    formPhonePh: '+91',
    formEmail: 'Email',
    formEmailPh: 'you@email.com',
    formDate: 'Event Date',
    formService: 'Service Needed',
    formMessage: 'Tell Us More',
    formMessagePh: 'Event location, number of guests, print quantity or anything else we should know (max 500 characters)',
    submit: 'Send Enquiry',
    sending: 'Sending...',
    successTitle: 'Thank You!',
    successText: 'Your enquiry has been received. Our team will contact you shortly with the details you need.',
    successButton: 'Send another enquiry',
    errorNetwork: 'Network error. Please check your connection and try again.',
    errorGeneric: 'Something went wrong. Please try again.',
    serviceOptions: [
      'Wedding Photography',
      'Pre-Wedding / Engagement',
      'Baby & Newborn',
      'Videography & Film',
      'Corporate & Product',
      'Photo Frames / Albums',
      'Visiting Cards / ID Cards',
      'Pamphlets / Brochures / Flex',
    ],
  },
  footer: {
    blurb: 'Turning Moments Into Memories. A photography, videography and creative design studio serving families and businesses across Tamil Nadu since 1988.',
    explore: 'Explore',
    ourServices: 'Our Services',
    reachUs: 'Reach Us',
    weddings: 'Wedding Photography',
    prewedding: 'Pre-Wedding Shoots',
    baby: 'Baby & Newborn',
    videography: 'Videography & Film',
    frames: 'Photo Frames',
    cards: 'Visiting Cards & Flex',
    address: 'Based in Tamil Nadu, India',
    origin: 'Online Services & Bookings Available',
    hours: 'Mon – Sat, 9:30 AM – 8:30 PM',
    rights: 'All rights reserved.',
    bottom: 'Photography • Videography • Creative Design',
  },
  pages: {
    about: {
      breadcrumb: 'About',
      label: 'Our Story',
      title: 'A Studio Rooted In Tamil Nadu, Since 1988',
      description: 'What began in 1988 as a small studio in Thirupathur, Sivagangai Dist. is today a complete photography, videography and creative design house trusted by families and businesses.',
    },
    services: {
      breadcrumb: 'Services',
      label: 'Photography & Videography',
      title: 'Stories We Love To Tell, Frame By Frame',
      description: 'Weddings, pre-wedding shoots, baby sessions, corporate work and cinematic films — every service is delivered by our own in-house team with a modern, unhurried approach.',
    },
    wedding: {
      breadcrumb: 'Wedding',
      label: 'Wedding Photography',
      title: 'Wedding Photography, Films & Albums — All From One Team',
      description:
        'Candid and traditional wedding photography, cinematic films, drone coverage and premium albums across Madurai, Karaikudi and all of Tamil Nadu. Since 1988.',
    },
    printing: {
      breadcrumb: 'Printing',
      label: 'Print & Design Studio',
      title: 'Design, Print And Finish — All Under One Roof',
      description: 'Photo frames, visiting cards, ID cards, pamphlets, brochures, flex and banners. Designed and printed by our own team with premium finishes and dependable timelines.',
    },
    gallery: {
      breadcrumb: 'Gallery',
      label: 'Portfolio',
      title: "Moments We've Turned Into Memories",
      description: 'A growing collection of weddings, pre-wedding stories, babies, portraits, corporate shoots and celebrations — captured across Tamil Nadu. Tap any frame to see it larger.',
    },
    contact: {
      breadcrumb: 'Contact',
      label: "Let's Talk",
      title: 'Book A Shoot Or Get A Print Quote',
      description: 'Call or WhatsApp us on {{phone}}, or send an enquiry and our team will get back within a day. We serve families and businesses across Tamil Nadu.',
    },
  },
  cta: {
    defaultEyebrow: "Let's Create Together",
    about: {
      eyebrow: 'Work With Us',
      title: 'Let Us Tell Your Story, Beautifully',
      description: "From a single portrait to a full wedding or a brand campaign, our team is ready to plan it with you. Reach out and let's talk about your date.",
    },
    services: {
      eyebrow: 'Plan Your Shoot',
      title: "Tell Us Your Date, We'll Handle The Rest",
      description: "Share your event details and the style you love. We'll suggest the right package, locations and creative direction for your budget.",
    },
    printing: {
      eyebrow: 'Need It Printed?',
      title: 'Send Your Design Or Let Us Create One',
      description: "Share your requirement and quantity — visiting cards, ID cards, brochures, frames or flex banners — and we'll get back with pricing and turnaround time.",
    },
    gallery: {
      eyebrow: 'Like What You See?',
      title: "Let's Create Frames You'll Treasure",
      description: "Tell us the occasion and the mood you want, and we'll bring it to life with the same care you see in this gallery.",
    },
    weddingStories: {
      eyebrow: 'Your Story Next',
      title: 'Ready To Become Our Next Wedding Story?',
      description:
        'Share your date and venue and we will plan a coverage that captures every ritual, every emotion and every in-between moment.',
    },
  },
  frames: {
    label: 'Photo Frames',
    title: 'Frame Models For Every Wall And Every Story',
    intro: 'Choose from classic wood, ornate gold, frameless acrylic and large statement frames — printed, mounted and hand-finished in our studio.',
    samplesLabel: 'Design & Print Samples',
    items: {
      pf1: { name: 'Classic Teak Wall Frame', desc: 'Solid teak wood frame with a wide matte mount, finished by hand and ready to hang.', tag: 'Best Seller' },
      pf2: { name: 'Golden Ornate Frame', desc: 'Antique gold baroque frame that turns a single portrait into a statement piece.', tag: 'Premium' },
      pf3: { name: 'Collage Gallery Wall Set', desc: 'A curated set of seven frames arranged to tell your family story across one wall.', tag: 'Family Favourite' },
      pf4: { name: 'Acrylic Crystal Frame', desc: 'Frameless acrylic block with a floating print — crisp, modern and glass-clear.', tag: 'Modern' },
      pf5: { name: 'Table-Top Desk Frame', desc: 'Compact desk frame with a brass easel stand — perfect for gifting and shelves.', tag: 'Gift Ready' },
      pf6: { name: 'Living Room Statement Frame', desc: 'Oversized frame designed for living rooms and offices that need real presence.', tag: 'Large Format' },
    },
    samples: {
      ps1: { title: 'Visiting Cards', desc: 'Matte, textured and gold-foil finishes with spot UV accents.' },
      ps2: { title: 'ID Cards', desc: 'School, college and staff ID cards with lanyards and holders.' },
      ps3: { title: 'Brochures & Catalogues', desc: 'Bi-fold, tri-fold and multi-page brochures with clean layouts.' },
      ps4: { title: 'Flex & Banners', desc: 'Large format flex, vinyl and backdrops for every promotion.' },
    },
  },
  packages: {
    label: 'Packages',
    title: 'Packages Built Around You',
    intro: 'Every celebration is different, so every quote is tailored. Here is how our most-loved packages are put together — call us for exact pricing on your date.',
    popularBadge: 'Most Booked',
    items: {
      pk1: {
        name: 'Wedding Classic',
        subtitle: 'Full-day wedding coverage',
        features: [
          '1 Photographer + 1 Cinematographer',
          'Candid + Traditional coverage',
          '300+ edited photos',
          '1 Premium 30-sheet album',
          'Highlight teaser video',
        ],
      },
      pk2: {
        name: 'Wedding Signature',
        subtitle: 'Our most booked package',
        features: [
          '2 Photographers + 1 Cinematographer',
          'Candid, traditional + drone',
          '600+ edited photos',
          '2 Premium albums + calendar',
          'Full wedding film + teaser',
          'Same-day edit reel',
        ],
      },
      pk3: {
        name: 'Baby & Family',
        subtitle: 'Studio milestone sessions',
        features: [
          'Studio + themed props',
          'Newborn / birthday coverage',
          '100+ edited photos',
          'Family group portraits',
          '1 Framed wall print',
        ],
      },
      pk4: {
        name: 'Corporate & Brand',
        subtitle: 'Business, product & events',
        features: [
          'Team & executive portraits',
          'Product / catalogue shoot',
          'Event & conference coverage',
          'Retouched brand-ready files',
          'Print collateral design',
        ],
      },
    },
  },
  wedding: {
    intro: {
      label: 'Wedding Coverage',
      title: 'Your Wedding, Told The Way It Felt',
      para1:
        'From the muhurtham to the last dance, our team moves quietly through your day — capturing the rituals, the laughter, the happy tears and the little in-between moments that make your story yours.',
      para2:
        'Every wedding package is built around your date, venues and budget. Candid and traditional photography, cinematic films, drone coverage, albums and same-day edits are all handled by one in-house team.',
      quote: 'People, places, emotions — our lens, your story.',
      highlights: {
        h1: 'Candid & Traditional',
        h2: '4K Cinematic Films',
        h3: 'Drone Coverage',
        h4: 'Premium Albums',
      },
    },
    packages: {
      label: 'Wedding Packages',
      title: 'Packages For Every Wedding',
      intro:
        'Whether it is an intimate muhurtham or a grand three-day celebration, every quote is tailored to your date. Reach out for exact pricing.',
      popularBadge: 'Most Booked',
      items: {
        wp1: {
          name: 'Wedding Classic',
          subtitle: 'Full-day wedding coverage',
          features: [
            '1 Photographer + 1 Cinematographer',
            'Candid + traditional coverage',
            '300+ edited photos',
            '1 Premium 30-sheet album',
            'Highlight teaser video',
          ],
        },
        wp2: {
          name: 'Wedding Signature',
          subtitle: 'Our most booked package',
          features: [
            '2 Photographers + 1 Cinematographer',
            'Candid, traditional + drone',
            '600+ edited photos',
            '2 Premium albums + calendar',
            'Full wedding film + teaser',
            'Same-day edit reel',
          ],
        },
        wp3: {
          name: 'Wedding Royal',
          subtitle: 'Grand multi-day celebration',
          features: [
            '3 Photographers + 2 Cinematographers',
            'Candid, traditional, drone + live stream',
            '1000+ edited photos',
            '3 Premium albums + framed prints',
            'Feature film + teaser + reels',
            'Pre-wedding shoot included',
          ],
        },
      },
    },
    gallery: {
      label: 'Wedding Gallery',
      title: 'Weddings We Have Told',
      intro:
        'Candid rituals, bridal portraits, pre-wedding stories and mandap moments captured across Tamil Nadu. Tap any frame to view it larger.',
      categories: {
        all: 'All',
        wedding: 'Wedding Day',
        prewedding: 'Pre-Wedding',
        rituals: 'Rituals',
      },
      items: {
        wg1: { title: 'Garland Exchange — Muhurtham', place: 'Madurai' },
        wg2: { title: 'Bridal Portrait — Kanjivaram', place: 'Karaikudi' },
        wg3: { title: 'Mehendi & Bangles Detail', place: 'Madurai' },
        wg4: { title: 'Temple Gopuram Pre-Wedding', place: 'Rameswaram' },
        wg5: { title: 'Garden Pre-Wedding Story', place: 'Madurai' },
        wg6: { title: 'Mandapam Rituals', place: 'Karaikudi' },
        wg7: { title: 'Blessings & Family', place: 'Madurai' },
        wg8: { title: 'Temple Blessing Moment', place: 'Karaikudi' },
      },
    },
    timeline: {
      label: 'Wedding Day',
      title: 'How We Cover Your Wedding Day',
      intro:
        'One team, one timeline — from the first cup of morning coffee to the final album on your shelf. Here is how a typical wedding day unfolds with Shabi Media.',
      stepLabel: 'Step',
      noteTitle: 'Up to 14 hours on the day',
      noteText:
        'Most weddings are covered from morning preparation through the reception. Need more time across multiple days? We build the schedule around your rituals.',
      steps: {
        wt1: {
          time: '06:00 AM',
          title: 'Getting Ready',
          desc: 'Bridal and groom preparation, mehendi, jewellery and family moments — captured softly before the ceremony begins.',
        },
        wt2: {
          time: '08:30 AM',
          title: 'Muhurtham Rituals',
          desc: 'The sacred muhurtham, homam and priest blessings photographed with respect for every tradition and detail.',
        },
        wt3: {
          time: '10:30 AM',
          title: 'Garland Exchange',
          desc: 'The thaali and garland moments, happy tears and blessings — plus candid frames of the people around you.',
        },
        wt4: {
          time: '12:30 PM',
          title: 'Family & Portraits',
          desc: 'Organised family groups, couple portraits and the small in-between moments before the reception begins.',
        },
        wt5: {
          time: '06:00 PM',
          title: 'Reception & Couple Session',
          desc: 'Stage coverage, guest candid shots and a relaxed couple session with cinematic lighting and drone.',
        },
        wt6: {
          time: 'After the Day',
          title: 'Edit & Album Delivery',
          desc: 'Colour-graded edits, a teaser within days, then your retouched albums and framed prints delivered on schedule.',
        },
      },
    },
    reviews: {
      label: 'Real Couples',
      title: 'Couples Who Trusted Us With Their Day',
      intro:
        'Hundreds of families across Madurai, Karaikudi and Tamil Nadu have let us tell their wedding story. Here are a few of them, in their own words.',
      rating: '4.9 / 5 from 600+ wedding reviews',
      readStory: 'Read their full wedding story',
      items: {
        ct1: {
          name: 'Aarthi & Karthik',
          wedding: 'Temple Wedding — Madurai',
          quote: 'They captured every ritual so beautifully that watching the album still gives us goosebumps. The candid frames are simply priceless.'
        },
        ct2: {
          name: 'Divya & Suresh',
          wedding: 'Two-Day Celebration — Karaikudi',
          quote: 'From the mehendi to the reception, the team was everywhere without ever being in the way. Our full wedding film felt like a movie.'
        },
        ct3: {
          name: 'Priya & Vignesh',
          wedding: 'Destination Wedding — Rameswaram',
          quote: 'They travelled with us, handled the drone and the lighting effortlessly, and delivered our album right on time. Truly professional.'
        },
      },
    },
    faq: {
      label: 'Wedding FAQ',
      title: 'Wedding Questions, Answered',
      intro:
        'Cost, team size, delivery and travel — what couples ask us the most before booking their date. Cannot find your answer? Message us any time.',
      cardTitle: 'Ready to check your date?',
      cardText: 'Send us your wedding date and venue and we will confirm availability with a tailored quote.',
      items: {
        wf1: {
          q: 'How much does a wedding package cost?',
          a: 'Every wedding is different, so pricing depends on your date, number of days, venues and team size. Our most-booked Wedding Signature package typically covers two photographers, a cinematographer, drone coverage, edited photos and albums. Share your date and we will send an exact quote — with no hidden costs.',
        },
        wf2: {
          q: 'How many photographers will cover our wedding?',
          a: 'Depending on the package, we bring 1 to 3 photographers plus 1 to 2 cinematographers on the wedding day. For large functions we can add extra crew for the reception, muhurtham and family portraits so no moment is missed.',
        },
        wf3: {
          q: 'Do you provide drone coverage and a cinematic film?',
          a: 'Yes. Drone coverage and 4K cinematic films are available in our Signature and Royal packages, and can be added to any other package. You receive a teaser, a full wedding film and, on request, same-day edit reels for social media.',
        },
        wf4: {
          q: 'How long until we receive our photos and album?',
          a: 'Edited highlights are ready within 7–10 days of the wedding. Full retouched albums take about 3–4 weeks, and printed albums or frames are delivered within 1–2 weeks after design approval. We share a clear timeline the day you book.',
        },
        wf5: {
          q: 'How do we block our wedding date and what is the advance?',
          a: 'A 30% advance confirms and blocks your date, with the balance payable on delivery. You can pay by UPI, bank transfer or cash at the studio. WhatsApp us your date and we will hold it for you while we finalise the details.',
        },
        wf6: {
          q: 'Do you travel for outstation weddings?',
          a: 'Absolutely. We regularly cover weddings across Tamil Nadu and beyond. Shoots within Madurai and Karaikudi are covered in the package; for other locations a travel charge applies, and for far destinations we also include stay — always quoted upfront.',
        },
      },
    },
    cta: {
      eyebrow: 'Your Date Matters',
      title: 'Let Us Capture Your Wedding Beautifully',
      description:
        'Share your wedding date, venues and the style you love — we will suggest the right package and confirm availability the same day.',
    },
  },
  weddingStory: {
    seoLanguage: 'en',
    breadcrumb: 'Real Wedding Story',
    label: 'Case Study',
    title: 'Aarthi & Karthik — A Temple Wedding in Madurai',
    description:
      'A full-day South Indian temple wedding in Madurai, photographed from the morning muhurtham to the evening reception. The rituals, the people and the quiet in-between moments — this is their story.',
    backToWeddings: 'Back to wedding photography',
    facts: {
      label: 'At A Glance',
      dateLabel: 'Wedding Date',
      dateValue: '14 June 2024',
      venueLabel: 'Venue',
      venueValue: 'Meenakshi Amman Temple & Sri Lakshmi Mahal, Madurai',
      guestsLabel: 'Guests',
      guestsValue: '850 guests across two days',
      coverageLabel: 'Coverage',
      coverageValue: '2 Photographers • 1 Cinematographer • Drone',
      styleLabel: 'Photography Style',
      styleValue: 'Traditional muhurtham + candid storytelling',
    },
    story: {
      label: 'Their Story',
      title: 'From A College Canteen To The Muhurtham',
      para1:
        'Aarthi and Karthik met over shared notes and countless cups of filter coffee at a college in Madurai, and nine years later they stood under the same temple gopuram with jasmine in their hair. Their wedding was two days of colour, music and family — and they wanted it remembered exactly as it felt.',
      para2:
        'We began at 5:30 in the morning with the bridal preparation, the mehendi and the nervous excitement, and stayed until the last relatives left the reception stage. Between the muhurtham and the reception, our team captured the homam, the garland exchange, the happy tears of both mothers and the little cousins who stole the show.',
      para3:
        'Because the couple loved candid moments as much as the rituals, we moved quietly through the day — two photographers for different angles, a cinematographer for the film and a drone for the grand temple and mandapam shots. The result is a set that feels warm, unhurried and completely theirs.',
    },
    review: {
      quote:
        'We were nervous about being photographed all day, but the team felt like family by the end. They caught moments we did not even know had happened — our grandmothers laughing together, our first look. Watching the film still makes us cry.',
      name: 'Aarthi & Karthik',
      role: 'Temple Wedding — Madurai',
    },
    timeline: {
      label: 'The Wedding Day',
      title: 'How Their Day Unfolded',
      intro:
        'A real timeline from Aarthi and Karthik\'s wedding day in Madurai — exactly how our team covered every ritual and every celebration.',
      stepLabel: 'Step',
      noteTitle: 'Covered start to finish',
      noteText:
        'From the first cup of morning coffee to the final reception dance, we stayed for the whole day. Planning a wedding of your own? Let us build a timeline around your rituals.',
      steps: {
        ws1: {
          time: '05:30 AM',
          title: 'Bridal & Groom Preparation',
          desc: 'Mehendi, jewellery and the quiet moments at home before the ceremony — including the first look at the bridal saree.',
        },
        ws2: {
          time: '08:00 AM',
          title: 'Muhurtham At The Temple',
          desc: 'The sacred muhurtham, homam and priest blessings inside the Madurai temple, photographed with respect for every tradition.',
        },
        ws3: {
          time: '10:30 AM',
          title: 'Garland Exchange & Thaali',
          desc: 'The garland exchange, the thaali moment and the happy tears — captured from two angles without ever interrupting the ceremony.',
        },
        ws4: {
          time: '12:30 PM',
          title: 'Family Blessings & Portraits',
          desc: 'Organised family groups, the rice-showering blessing and couple portraits in the temple courtyard during golden light.',
        },
        ws5: {
          time: '06:30 PM',
          title: 'Reception & Couple Session',
          desc: 'Stage coverage, guest candid moments, a drone shot of the venue and a relaxed couple session to close the day.',
        },
      },
    },
    gallery: {
      label: 'Photo Story',
      title: 'Frames From Their Wedding',
      intro:
        'A selection of photographs from Aarthi and Karthik\'s two-day celebration in Madurai. Tap any frame to view it larger.',
      categories: {
        story: 'All Frames',
      },
      items: {
        sg1: { title: 'Garland Exchange — Muhurtham', place: 'Madurai' },
        sg2: { title: 'Bridal Prayer Before The Ceremony', place: 'Madurai' },
        sg3: { title: 'Mehendi & Bangles Detail', place: 'Madurai' },
        sg4: { title: 'Mandapam Rituals & Homam', place: 'Madurai' },
        sg5: { title: 'Family Blessings & Rice Shower', place: 'Madurai' },
        sg6: { title: 'Reception Stage Portrait', place: 'Madurai' },
      },
    },
    cta: {
      eyebrow: 'Your Story Next',
      title: 'Let Us Tell Your Wedding Story This Way',
      description:
        'Share your date and venue and we will plan a full-day coverage that captures every ritual, every emotion and every little in-between moment.',
    },
  },
  weddingStories: {
    breadcrumb: 'Real Wedding Stories',
    label: 'Real Couples',
    title: 'Real Wedding Stories',
    description:
      'A growing collection of weddings we have told across Tamil Nadu — the rituals, the people and the moments in between, each with its own photo story.',
    featuredLabel: 'Featured Story',
    readStory: 'Read the full story',
    viewAll: 'View all real wedding stories',
    backToHub: 'Back to all wedding stories',
    gridTitle: 'More Real Weddings',
    gridIntro:
      'Every couple, every town and every ritual, told with the same care. Browse a few more of the stories we have captured.',
    related: {
      label: 'Keep Exploring',
      title: 'More Real Wedding Stories',
      intro:
        'Loved this story? Continue through more real weddings we have photographed across Madurai, Karaikudi and Tamil Nadu — each with its own rituals, timeline and photo story.',
      prev: 'Previous stories',
      next: 'Next stories',
    },
    detail: {
      storyLabel: 'Their Story',
      factsLabel: 'At A Glance',
      timelineLabel: 'The Wedding Day',
      timelineTitle: 'How Their Day Unfolded',
      galleryLabel: 'Photo Story',
      galleryTitle: 'Frames From Their Wedding',
      galleryIntro: 'A selection of photographs from this celebration. Tap any frame to view it larger.',
      ctaEyebrow: 'Your Story Next',
      ctaTitle: 'Let Us Tell Your Wedding Story This Way',
      ctaDescription:
        'Share your date and venue and we will plan a full-day coverage that captures every ritual, every emotion and every in-between moment.',
    },
  },
  weddingStoriesFaq: {
    label: 'Wedding Photography FAQ',
    title: 'Wedding Photography Cost & Booking, Answered',
    intro:
      'Cost, travel, booking and delivery — the questions couples ask before choosing a wedding photographer in Madurai and across Tamil Nadu. Cannot find your answer? Message us any time.',
    cardTitle: 'Planning your wedding?',
    cardText:
      'Send us your date and venue and we will confirm availability with a tailored quote — no hidden costs.',
    items: {
      wsf1: {
        q: 'How much does wedding photography cost in Madurai?',
        a: 'Wedding photography in Madurai typically starts from around ₹45,000 for a single-day Classic package and goes up to ₹2,00,000+ for a grand multi-day Royal package with two or three photographers, cinematographers and drone coverage. The final price depends on your date, number of days, venues and team size. Share your date and we will send an exact quote with no hidden costs.',
      },
      wsf2: {
        q: 'What affects the cost of a wedding photographer in Tamil Nadu?',
        a: 'The main factors are the number of days and functions, the number of photographers and cinematographers, drone coverage, the distance of your venues, and the album or print products you choose. Adding a pre-wedding shoot, live streaming or same-day edit reels also changes the price. We list every inclusion clearly so you always know what you are paying for.',
      },
      wsf3: {
        q: 'Do you travel outside Madurai and Karaikudi for weddings?',
        a: 'Yes. We regularly photograph weddings across Tamil Nadu — Karaikudi, Rameswaram, Trichy, Thanjavur, Chennai and beyond. Shoots within Madurai and Karaikudi are covered in the package; for other locations a travel charge applies, and for far destinations we also include stay, always quoted upfront.',
      },
      wsf4: {
        q: 'How do we book our date and what advance is required?',
        a: 'A 30% advance confirms and blocks your wedding date, with the balance payable on delivery. You can pay by UPI, bank transfer or cash. WhatsApp us your date and venue and we will confirm availability the same day, hold your date and finalise the package details with you.',
      },
      wsf5: {
        q: 'Can we see more real wedding stories before booking?',
        a: 'Absolutely — that is exactly why we publish our real wedding stories. Browse each story to see the rituals, the photo timeline and the couple\'s review for weddings in Madurai, Karaikudi, Rameswaram, Trichy and Thanjavur. When you find the style you love, message us and we will plan yours the same way.',
      },
    },
  },
}

export default translation